import type { MouseEvent } from "react";
import type {
  ToolboxQuestionI,
  UnknownQuestionI,
} from "../../../../../../types";
import InputQuestionCard from "./InputQuestionCard";
import MultipleChoiceQuestionCard from "./MultipleChoiceQuestionCard";
import RatingScaleQuestionCard from "./RatingScaleQuestionCard";

export default function QuestionCard({
  question,
  onChange,
  onRemove,
  index,
}: {
  question: ToolboxQuestionI;
  onChange: (q: ToolboxQuestionI) => void;
  onRemove: () => void;
  index: number;
}) {
  const card = (() => {
    switch (question.type) {
      case "input":
        return (
          <InputQuestionCard
            question={question}
            onChange={onChange}
            onRemove={onRemove}
            index={index}
          />
        );
      case "multiple_choice":
        return (
          <MultipleChoiceQuestionCard
            question={question}
            onChange={onChange}
            onRemove={onRemove}
            index={index}
          />
        );
      case "rating_scale":
        return (
          <RatingScaleQuestionCard
            question={question}
            onChange={onChange}
            onRemove={onRemove}
            index={index}
          />
        );
      default:
        return (
          <div className="rounded-md border border-gray-200 p-3 text-sm text-gray-400">
            Unknown question type:{" "}
            {(question as unknown as UnknownQuestionI).type}
          </div>
        );
    }
  })();

  const stopDragFromInteractive = (e: MouseEvent) => {
    const t = e.target as HTMLElement;
    if (
      t.closest("input, textarea, select, button, label, [role='checkbox']")
    ) {
      e.stopPropagation();
    }
  };

  return <div onMouseDown={stopDragFromInteractive}>{card}</div>;
}
